import { Briefcase, Truck, type LucideIcon } from 'lucide-react'

type AppRole = 'manager' | 'driver'

const ROLE_META: Record<AppRole, { label: string; Icon: LucideIcon }> = {
  manager: { label: 'Менеджер', Icon: Briefcase },
  driver: { label: 'Водитель', Icon: Truck },
}

const ORDER: AppRole[] = ['manager', 'driver']

function heldRoles(roles: string[]): AppRole[] {
  return ORDER.filter((r) => roles.includes(r))
}

type CabinetSwitcherProps = {
  roles: string[]
  activeRole: string
  onSwitch: (role: AppRole) => void
}

// Lets a multi-role user switch the active cabinet. Hidden unless the user holds more than
// one application role. Switching only changes landing + navigation; access to a cabinet is
// always governed by whether the user actually holds the role (see AuthGuard).
export default function CabinetSwitcher({ roles, activeRole, onSwitch }: CabinetSwitcherProps) {
  const held = heldRoles(roles)
  if (held.length < 2) return null

  return (
    <div className="app-cabinet-switcher app-cabinet-switcher--drawer" role="group" aria-label="Выбор кабинета">
      <span className="app-cabinet-switcher__label">Кабинет</span>
      <div className="app-cabinet-switcher__row">
        {held.map((r) => {
          const { label, Icon } = ROLE_META[r]
          const active = r === activeRole
          return (
            <button
              key={r}
              type="button"
              onClick={() => onSwitch(r)}
              className={`app-cabinet-switcher__chip${active ? ' is-active' : ''}`}
              aria-pressed={active}
            >
              <Icon className="app-cabinet-switcher__chip-icon" />
              <span>{label}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
